import React, { useState } from 'react';
import { observer } from 'src/utils/mobx-react';
import { HeadlineCarouselState } from './HeadlineCarousel.state';
import { HeadlineCarouselNav } from './HeadlineCarouselNav';
import { HeadlineForm } from './HeadlineCarouselsForm/HeadlineCarouselsForm';
import { HeadlineCarouselList } from './HeadlineCarouselsList/HeadlineCarouselList';
import { useAppStateContext } from 'src/AppState/AppState';
import {
    ColumnOneOfTwo,
    MainContent,
    TwoColumnResponsiveContentReverse,
} from 'src/domains/layouts/shared/layout/Layout.style';

export const HeadlineCarousel = observer('HeadlineCarousel', () => {
    const { appCasinoState } = useAppStateContext();
    const [headlineCarouselsState] = useState(() => new HeadlineCarouselState(appCasinoState.gameStore));

    return (
        <MainContent>
            <HeadlineCarouselNav headlineCarouselsState={headlineCarouselsState} />

            {headlineCarouselsState.collection === 'casino' && (
                <TwoColumnResponsiveContentReverse>
                    <ColumnOneOfTwo>
                        <HeadlineCarouselList headlineCarouselsData={headlineCarouselsState.headlineBannersData} />
                    </ColumnOneOfTwo>

                    <ColumnOneOfTwo>
                        <HeadlineForm headlineCarouselState={headlineCarouselsState} />
                    </ColumnOneOfTwo>
                </TwoColumnResponsiveContentReverse>
            )}

            {headlineCarouselsState.collection === 'live-casino' && (
                <TwoColumnResponsiveContentReverse>
                    <ColumnOneOfTwo>
                        <HeadlineCarouselList headlineCarouselsData={headlineCarouselsState.headlineBannersData} />
                    </ColumnOneOfTwo>

                    <ColumnOneOfTwo>
                        <HeadlineForm headlineCarouselState={headlineCarouselsState} />
                    </ColumnOneOfTwo>
                </TwoColumnResponsiveContentReverse>
            )}

            {headlineCarouselsState.collection === 'virtuals' && (
                <TwoColumnResponsiveContentReverse>
                    <ColumnOneOfTwo>
                        <HeadlineCarouselList headlineCarouselsData={headlineCarouselsState.headlineBannersData} />
                    </ColumnOneOfTwo>

                    <ColumnOneOfTwo>
                        <HeadlineForm headlineCarouselState={headlineCarouselsState} />
                    </ColumnOneOfTwo>
                </TwoColumnResponsiveContentReverse>
            )}
        </MainContent>
    );
});
